import { Head } from "@inertiajs/react"
import { Mail } from "lucide-react"

import AuthAlert from "@/components/tuw/auth/AuthAlert"
import { AuthHeading, HeroIcon } from "@/components/tuw/auth/AuthHeading"
import AuthLayout from "@/components/tuw/auth/AuthLayout"
import { CsrfField } from "@/components/tuw/auth/fields"
import ResendButton from "@/components/tuw/auth/ResendButton"
import { maskEmail } from "@/lib/maskEmail"

import { BackToSignIn } from "./ForgotPassword"

// Check your inbox (P11-H2 Spare Key): the one landing after a reset request,
// registered email or not. The address arrives in flash (never in the URL)
// and is shown masked. "Resend the link" re-posts the same request; after a
// resend the server sets `resent` and the button holds a 30 second cooldown.
export default function ResetSent({ action, email, resent = false, links }) {
  return (
    <AuthLayout panel="reset" swap={{ prompt: "New here?", label: "Create an account", href: links.signUp }}>
      <Head title="Check your inbox · The Urban Writers" />

      <HeroIcon icon={Mail} />

      <AuthHeading title="Check your inbox">
        If an account exists for <b className="font-display">{maskEmail(email)}</b>, we’ve sent a reset link. It
        expires in <b>6 hours</b>.
      </AuthHeading>

      <AuthAlert tone="quiet">
        Not there after a minute? Check your spam folder, or make sure you used the email you signed up with.
      </AuthAlert>

      <div className="flex flex-wrap items-center gap-1.5 text-[13px] text-muted-foreground">
        <span>Didn’t get it?</span>
        <form method="post" action={action}>
          <CsrfField />
          <input type="hidden" name="user[email]" value={email} />
          <input type="hidden" name="resend" value="1" />
          <ResendButton cooldown={resent ? 30 : 0} />
        </form>
        <span>·</span>
        <a href={links.forgot} className="font-semibold text-foreground">
          Use a different email
        </a>
      </div>

      <BackToSignIn href={links.signIn} />
    </AuthLayout>
  )
}
